import { BaseModel } from './../base/base.model';

export class SosField extends BaseModel {
    id: number;
    name: string = null;
    sos_field_name: string = null;
    sos_department_id: number = null;
    created_at: Date = null;
    updated_at: Date = null;

    constructor(obj) {
        super();
        this.initializeData(obj, this);
    }
}
